import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import type { AdminState } from '../store/admin.slice';

export function useAdminData(): AdminState {
    return useSelector((state: RootState) => state.admin);
}
